// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';

export const addLabor = () => ({
    type: actions.CREATE_CLAIM_WEAR_PARTS_LABOR
});

export const changeHours = (index, laborHours) => ({
    index,
    laborHours,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_LABOR_HOURS
});

export const changeLaborLocation = (index, location) => ({
    index,
    location,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_LABOR_LOCATION
});

export const changeLaborType = (index, laborType) => ({
    index,
    laborType,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_LABOR_TYPE
});

export const changeLaborComments = (index, spgJobCode) => ({
    index,
    spgJobCode,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_LABOR_COMMENTS
});

export const deleteLabor = index => ({
    index,
    type: actions.DELETE_CLAIM_WEAR_PARTS_LABOR
});

export const changeTechId = (index, techId) => ({
    index,
    techId,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_TECH_ID
});



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/labor.js